import { AssignmentDialog } from './AssignmentDialog';
import { OrganizationsListCreateEditDialog } from './OrganizationsListCreateEditDialog';
import { useOrganizationsListDialogContext } from '../context/OrganizationsListDialogContext';

const OrganizationsListDialogs = () => {
  const { state } = useOrganizationsListDialogContext();

  switch (state.activeDialog) {
    case 'createOrganization':
      return <OrganizationsListCreateEditDialog dialogType={'createOrganization'} />;
    case 'editOrganization':
      return (
        <OrganizationsListCreateEditDialog
          dialogType={'editOrganization'}
          organizationData={state.data ?? undefined}
        />
      );
    case 'selectDatasets':
      if (state.data) {
        return <AssignmentDialog data={state.data} />;
      }
      break;
    default:
      return null;
  }
};

export default OrganizationsListDialogs;
